import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_RESET_STATS_OFF, REQUEST_SURRENDER_OFF } from '../../HOME/REDUX/actions';
import { UNSELECT_TILE, SET_COLOR_SET } from '../REDUX/actions';
import { MODE_AI, MODE_SOLO } from '../../HOME/const';
import _ from 'lodash';
import { delay, playSound, windowSize, dbget, dbset } from '../../HOME/utils';
import * as f from '../logic';
import '../styles.css';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import Tile from './Tile';
import { PN_BLUE, PN_GREEN, PN_YELLOW, PN_INDIGO, PN_RED } from '../../PN/const';

const Board = () => {
  const dispatch = useDispatch();
  const [_dummy, setDummy] = useState(false);
  const { pt, common } = useSelector(state => state);
  const { restart } = common;
  const { mode, size } = pt;
  const ai = mode === MODE_AI;
  const solo = mode === MODE_SOLO;
  let [l, setLocal] = useState({ tiles: [] });
  const [blocked, setBlocked] = useState(0);

  const forceUpdate = () => setDummy(!_dummy);

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  useEffect(() => {
    window.addEventListener('resize', forceUpdate);
    l.mounted = true;

    if (restart) {
      // TODO
    } else {
      load();
    }

    return () => {
      window.removeEventListener('resize', forceUpdate);
      l.mounted = false;

      dispatch(REQUEST_RESET_STATS_OFF);
      dispatch(REQUEST_SURRENDER_OFF);
      dispatch(UNSELECT_TILE);
    };
  }, [restart, dispatch]);

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const load = () => {
    dbget(f.boardKey(pt), json => {
      if (json) {
        doLoad(json);
      } else {
        doInit();
      }
    });
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const doLoad = json => {
    const { tiles, turn } = JSON.parse(json);
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const doInit = () => {
    l.tiles = [];

    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        l.tiles.push({ home: { row: i + 1, col: j + 1 } });
      }
    }

    while (true) {
      l.tiles = _.shuffle(l.tiles);

      let ok = true;

      _.each(l.tiles, (tile, i) => {
        tile.row = Math.floor(i / size) + 1;
        tile.col = (i % size) + 1;

        if (tile.row === tile.home.row && tile.col === tile.home.col) {
          ok = false;
          return false;
        }
      });

      if (ok) {
        break;
      }
    }

    dispatch({ type: SET_COLOR_SET, index: _.random(11) });

    forceUpdate();
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const toJson = () => {
    const ob = { tiles: l.tiles };
    const incl = ['tiles'];

    if (solo) {
      //
    } else {
      ob.turn = pt.turn;
      incl.push('turn');
    }

    const json = JSON.stringify(ob, incl);
    return json;
  };

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const save = () => {
    dbset(f.boardKey(pt), toJson());
  };

  let { x: wx, y: wy } = windowSize();
  wy -= 200;
  let width = Math.min(wx, wy) * 0.9;
  width = Math.min(width, 500);
  width = (width / size) * 0.95;
  const gap = width * 0.025;

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  return (
    <div className="pt-board" style={{ rowGap: gap, columnGap: gap }}>
      {_.map(l.tiles, (tile, i) => {
        const shadow = width / 10;
        const style = { gridArea: `${tile.row}/${tile.col}`, boxShadow: `${shadow}px ${shadow}px ${shadow}px black` };

        return <Tile key={i} props={pt} style={style} width={width} tile={tile} />;
      })}
    </div>
  );
};

export default Board;
